import React from 'react';
import styled from '@emotion/styled';
import { alignItems, opacity, space, width } from 'styled-system';
import type { AlignItemsProps, WidthProps } from 'styled-system';

import { Button } from 'common/components/Button';
import { HeadlineH8 } from 'common/components/Typography';

const StyledButton = styled(Button)<WidthProps & AlignItemsProps>`
  ${width};
  ${alignItems};
  ${space};
`;

const Img = styled.img<WidthProps>`
  ${width};
  ${opacity};
`;

const buttonStyles = {
  kind: 'secondary-v2' as const,
  alignItems: 'center',
  width: 1,
  py: 'sp_12',
};

const imgStyles = {
  height: '22px',
};

interface ThirdPartyButtonProps {
  label: string;
  imgSrc: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

const ThirdPartyButton = ({
  label,
  imgSrc,
  onClick,
  isLoading,
  isDisabled,
}: ThirdPartyButtonProps) => {
  return (
    <StyledButton {...buttonStyles} isLoading={isLoading} onClick={onClick} disabled={isDisabled}>
      <Img
        {...imgStyles}
        src={imgSrc}
        aria-hidden="true"
        {...(isDisabled ? { opacity: '0.5' } : {})}
      />
      <HeadlineH8
        ml="sp_6"
        color={isDisabled ? 'sys.neutral.text.inactive' : 'sys.neutral.text.default'}
      >
        {label}
      </HeadlineH8>
    </StyledButton>
  );
};

export default ThirdPartyButton;
